<template>
  <v-dialog
      v-model="isOpen"
      max-width="500"
      persistent
  >
    <v-card>
      <v-card-title class="headline">
        เลือกประเภทการสั่งซื้อ
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="text-center">
              <div class="mb-4">
                ลูกค้ามีคะแนนสะสม
                <span class="orange--text text-h6">
                  <v-icon color="orange">mdi-star</v-icon>
                  {{ $helper.number_format(loyaltyBalance, 0) }}
                </span>
                แต้ม
              </div>
              <div class="mb-4">
                ต้องการสร้างออเดอร์ประเภทใด?
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-btn
                  block
                  color="primary"
                  large
                  @click="onChoose('money')"
              >
                <v-icon left>mdi-cash</v-icon>
                สั่งซื้อด้วยเงิน
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                  block
                  color="orange"
                  dark
                  large
                  @click="onChoose('point')"
              >
                <v-icon left>mdi-star</v-icon>
                แลกด้วยแต้ม
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="onCancel"
        >
          ยกเลิก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator'

@Component({
  components: {}
})
export default class OrderTypeChooserDialog extends Vue {
  isOpen = false
  loyaltyBalance = 0
  onApplyCallback: ((orderType: 'money' | 'point') => void) | null = null

  mounted() {
    this.$root.$on('openOrderTypeChooser', this.open)
  }

  beforeDestroy() {
    this.$root.$off('openOrderTypeChooser', this.open)
  }

  open({loyaltyBalance, onApply}: { loyaltyBalance: number, onApply: (orderType: 'money' | 'point') => void }) {
    this.loyaltyBalance = loyaltyBalance
    this.onApplyCallback = onApply
    this.isOpen = true
  }

  onChoose(orderType: 'money' | 'point') {
    if (this.onApplyCallback) {
      this.onApplyCallback(orderType)
    }
    this.isOpen = false
  }

  onCancel() {
    this.isOpen = false
    this.onApplyCallback = null
  }
}
</script>
